<template>
    <div class="organization">
        <h1 class="head">架構及成員</h1>
        <div class="content" v-html="association.structure"></div>
    </div>
</template>

<script>
export default {
  data(){
      return {
        association: this.$store.getters.association,
      }
  },
  methods: {
  }
}
</script>

<style lang="scss">
    .organization {
        width: 1000px;
        margin: 0 auto;
        background-color: #fff;
    }

    .organization * {
        font-size: 16px !important;
        font-weight: 400;
        line-height: 18px;
    }

    .organization > .content {
        padding: 0 12px;
    }

    .organization span {
        color: #1f1f1f;
    }

    .organization > .head {
        height: 120px;
        line-height: 120px;
        font-size: 24px !important;
        color: #1f1f1f;
        font-weight: bold;
        text-align: center;
        text-align: center;
    }

    .organization > .img-list img {
        width: 92%;
        margin: 0 auto;
        margin-bottom: 20px;
    }

     .organization h2 {
         font-size: 18px !important;
         font-weight: bold;
         line-height: 42px;
         margin-top: 20px;
     }

     .organization strong {
         font-size: 16px;
         font-weight: bold;
         line-height: 24px;
     }

     .organization p {
         font-size: 16px !important;
         font-weight: 400;
         line-height: 24px;
         margin-bottom: 8px;
     }

     @media only screen and (max-width: 1050px) {
         .organization {
             width: 100%;
         }
     }
</style>
